import { SlidingDoorComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';
import { removeProductsAndUpdateInnerLights } from 'rangeConfig/pax/utils/removeProducts';

const removeDoorsFromSelectedEntity = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return null;
  }
  const hingedDoors = coreApi.entities.getDescendantsWithComponent(
    selectedEntity,
    ComponentIds.DOOR_COMPONENT_ID
  );
  const slidingDoor = coreApi.entities.getDescendantsWithComponent(
    selectedEntity,
    SlidingDoorComponent.id
  );
  if (hingedDoors.length > 0) {
    removeProducts(hingedDoors, coreApi, products);
  } else if (slidingDoor) {
    removeProductsAndUpdateInnerLights(slidingDoor, coreApi);
  }
};

export default removeDoorsFromSelectedEntity;
